import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Preloader from "@/components/site/Preloader";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import VehicleShowcase from "@/components/site/VehicleShowcase";
import Services from "@/components/site/Services";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import useSEO from "@/hooks/useSEO";

export default function Landing() {
  useSEO({
    title: "OKA VTC — Chauffeur privé VTC à Lyon | Transferts aéroport, mariage, affaires",
    description:
      "Chauffeur VTC privé à Lyon : transferts aéroport Lyon Saint-Exupéry, mise à disposition, véhicule de mariage et déplacements professionnels. Réservation en ligne, ponctualité garantie.",
  });

  useEffect(() => {
    const hash = window.location.hash?.slice(1);
    if (!hash || hash === "instant") return;
    // Attend la fin de l'écran de chargement (~2.1s + animation de sortie)
    // avant de défiler vers l'ancre demandée (ex: lien QR code -> #booking).
    const t = setTimeout(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth" });
    }, 2300);
    return () => clearTimeout(t);
  }, []);

  return (
    <div data-testid="landing-page" className="relative bg-[#F8F9FA] overflow-x-hidden">
      <Preloader />
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <VehicleShowcase />
      <Services />
      <Booking />
      <Footer />
    </div>
  );
}
